import { onUnmounted, watch } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { createFaviconBadge } from 'dashboard/helper/faviconHelper';

export const useNotificationFavicon = () => {
  const hasUnread = useMapGetter('notifications/getHasUnreadNotifications');
  const favicon = createFaviconBadge(window.globalConfig?.FAVICON_BADGE);

  watch(hasUnread, favicon.update, { immediate: true });
  onUnmounted(favicon.reset);
};
